import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import fetchBusinessEmployees from 'actions/businessTraveller/fetchBusinessEmployees'
import fetchBusinessApprovalRequests from 'actions/businessTraveller/fetchBusinessApprovalRequests'

interface Params {
  currentRegionCode: string,
  isEnabled?: boolean,
}

function useBusinessTravellerTripRequests(params: Params) {
  const { currentRegionCode, isEnabled = true } = params

  const appDispatch = useAppDispatch()
  const businessId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.business?.id)
  const employeeId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.employee?.id)
  const approvalRequests = useAppSelector(
    state => state.businessTraveller.approvalRequests?.request || [],
  )
  const employees = useAppSelector(state => state.businessTraveller.employees.all)
  const status = useAppSelector(state => state.businessTraveller.approvalRequests?.status)

  useEffect(() => {
    if (isEnabled && businessId) {
      appDispatch(fetchBusinessEmployees(businessId))
    }
  }, [appDispatch, businessId, isEnabled])

  useEffect(() => {
    if (isEnabled && businessId && currentRegionCode && employeeId && employees) {
      const employeesArray: Array<App.BusinessTraveller.EmployeeFromMeEndpoint> = Object.values(employees)
      appDispatch(fetchBusinessApprovalRequests(businessId, employeeId, currentRegionCode, employeesArray))
    }
  }, [appDispatch, businessId, employeeId, currentRegionCode, employees, isEnabled])

  const upcomingApprovals = approvalRequests.filter(request => request.isActive)
  const completedApprovals = approvalRequests.filter(request => !request.isActive)
  const approvedApprovals = approvalRequests.filter(request => request.status === 'APPROVED')

  return {
    upcoming: upcomingApprovals,
    completed: completedApprovals,
    approved: approvedApprovals,
    status,
  }
}

export default useBusinessTravellerTripRequests
